// Form Actions
const cart_root = window.Shopify.routes.root;
const checkoutEndpoint = getCheckoutEndpoint();

const cartLocale = `${cart_root}cart.js`;
const cartLocaleAdd = `${cart_root}cart/add.js`;
const cartUpdateLocale = `${cart_root}cart/update.js`;

attachListeners();

// Listen for drawer toggle
document.addEventListener('click', async event => {
  const toggle = event.target.closest('.cart-drawer-toggle');
  if(toggle) {
    event.preventDefault();
    await updateDrawer();
  } 
})

document.addEventListener('submit', async event => {
  const formSubmit = event.target.closest('.cart-drawer-submit');
  const upsellSubmit = event.target.closest('.cart-upsell-submit');
  const instafeedSubmit = event.target.closest('.cart-instafeed-submit');

  if(formSubmit) await handleFormSubmit(formSubmit);
  if(upsellSubmit) await handleAddFormSubmit(upsellSubmit);
  if(instafeedSubmit) await handleAddFormSubmit(instafeedSubmit);
})

document.addEventListener('change', async event => {
  const input = event.target.closest('.cart-drawer-item-input');

  if(input) {
    const key = event.target.closest('.cart-drawer-item').getAttribute('data-item-key');
    await fetch(cartUpdateLocale, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: { [key]: input.value } })
    })

    await updateDrawer();
  }
})

// Handle default submit
async function handleFormSubmit(form) {
  event.preventDefault()

  await fetch(cartLocaleAdd, {
    method: "post",
    body: new FormData(form)
  })

  await updateDrawer();
}

// Handle form add submit
async function handleAddFormSubmit(form) {
  event.preventDefault();

  const key = form.getAttribute('data-key');
  
  await fetch(cartUpdateLocale, {
    method: 'post',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ updates: { [key]: 1} })
  })

  await updateDrawer();
}

// Drawer utility
function openDrawer() {
  const cart_drawer = document.querySelector('.cart-drawer');
  
  if(!cart_drawer) return;

  if(cart_drawer.getAttribute('data-state') === 'closed') {
    cart_drawer.setAttribute('data-state', 'opening');
    cart_drawer.addEventListener('animationend', event => {
      cart_drawer.setAttribute('data-state', 'open');
    }, { once: true })
  }
  
  attachListeners();
}

function closeDrawer() {
  const cart_drawer = document.querySelector('.cart-drawer');

  if(!cart_drawer) return;

  if(cart_drawer.getAttribute('data-state') === 'open') {
    cart_drawer.setAttribute('data-state', 'closing');
    cart_drawer.addEventListener('animationend', event => {
      cart_drawer.setAttribute('data-state', 'closed');
    }, { once: true })
  }
}

function updateCheckoutEndpoint() {
  const drawer_checkout = document.querySelector('.cart-drawer-checkout');
  if(drawer_checkout) drawer_checkout.setAttribute('href', checkoutEndpoint);
}

function attachListeners() {
 // Close Drawer
  const cart_drawer = document.querySelector('.cart-drawer');
  const cart_drawer_close = document.querySelector('.cart-drawer-close')
  const cart_drawer_box = document.querySelector('.cart-drawer-box');
  
  if(cart_drawer) cart_drawer.addEventListener('click', closeDrawer);
  if(cart_drawer_close) cart_drawer_close.addEventListener('click', closeDrawer);
  if(cart_drawer_box) cart_drawer_box.addEventListener('click', event => event.stopPropagation());


  // Update Quantities
  const quantitySelectorsDecrease = Array.from(document.querySelectorAll('button.cart-drawer-item-selector.decrease'));
  const quantitySelectorsIncrease = Array.from(document.querySelectorAll('button.cart-drawer-item-selector.increase'));
  if(quantitySelectorsDecrease) quantitySelectorsDecrease.forEach(selector => selector.addEventListener('click', event => { updateItemQuantity(event.target.closest('.cart-drawer-item'), -1) }));
  if(quantitySelectorsIncrease) quantitySelectorsIncrease.forEach(selector => selector.addEventListener('click', event => { updateItemQuantity(event.target.closest('.cart-drawer-item'), +1) }));

  // Remove Item
  const quantitySelectorsRemove = Array.from(document.querySelectorAll('button.cart-drawer-item-remove'));
  if(quantitySelectorsRemove) quantitySelectorsRemove.forEach(selector => selector.addEventListener('click', event =>{ updateItemQuantity(event.target.closest('.cart-drawer-item'), 0)}));

  // Upsell Slider Control Listeners
  const upsell_control_prev = document.querySelector('.cart-drawer-upsell-control.prev');
  const upsell_control_next = document.querySelector('.cart-drawer-upsell-control.next');

  if(upsell_control_prev) upsell_control_prev.addEventListener('click', event => updateUpsellSlider(Array.from(document.querySelectorAll('.cart-drawer-upsell-form')), -1));
  if(upsell_control_next) upsell_control_next.addEventListener('click', event => updateUpsellSlider(Array.from(document.querySelectorAll('.cart-drawer-upsell-form')), +1));

  // Update progress bar
  const progress_fill = document.querySelector('.cart-drawer-progress-fill');
  if(progress_fill) progress_fill.style.width = progress_fill.getAttribute('data-progress');

  // Prevent form submit when enter is pressed inside input[number] element
  const cart_drawer_form = document.querySelector('.cart-drawer-form');
  if(cart_drawer_form) cart_drawer_form.addEventListener('submit', event => event.preventDefault())
}

// Cart Drawer Updates
function updateCartCount() {
  let newCount;
  const cart_drawer_form = document.querySelector('form.cart-drawer-form');
  const cart_drawer_empty = document.querySelector('p.cart-drawer-empty');

  if(!cart_drawer_form && !cart_drawer_empty) return;
  
  if(cart_drawer_form) newCount = cart_drawer_form.getAttribute('data-count');
  
  if(cart_drawer_empty) newCount = 0;
  
  const counters = document.querySelectorAll('.header-cart__count');
  if(counters) counters.forEach(counter => counter.innerHTML = newCount);
    
}

async function updateDrawer() {
  const response = await fetch(window.Shopify.routes.root + "?section_id=section-cart-drawer");
  const content = await response.text();
  const html = document.createElement('div');

  html.innerHTML = content;
  const newbox = html.querySelector('.cart-drawer').innerHTML;
  document.querySelector('.cart-drawer').innerHTML = newbox;

  openDrawer();
  updateCartCount();
  updateCheckoutEndpoint();
}

// Update Cart Content
async function updateItemQuantity(item, modifier) {
  const key = item.getAttribute('data-item-key');
  const input = item.querySelector('input.cart-drawer-item-input');
  const quantity = modifier === 0 ? 0 : Number(input.value) + modifier; // If 0 is passed set item quantity to 0

  await fetch(cartUpdateLocale, {
    method: 'post',
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ updates: { [key]: quantity} })
  })

  await updateDrawer();
}

// Update Checkout endpoint
function getCheckoutEndpoint() {
  const rootURL = "https://little-big-friends.com/";
  const currentPath = window.location.href.replace(rootURL, "");
  const pathLocale = currentPath.split("/")[0];

  let endpointLocale = "";
  let endpointCart = "/checkout";
  
  if (pathLocale.includes("?")) {
    endpointLocale = pathLocale.split("?")[0];
  } else if(pathLocale !== "" && pathLocale !== "collections" && pathLocale !== "products") {
    endpointLocale = "/" + pathLocale;
  }
  
  const endpoint = endpointLocale + endpointCart;

  // console.log("Checkout endpoint:", endpoint)
  return endpoint
}

// Update Upsell Slider
function updateUpsellSlider(forms, modifier) {
  const focused = document.querySelector('.cart-drawer-upsell-form.focused');
  const currentIndex = forms.indexOf(focused) + modifier;
  const arrayLength = forms.length - 1;

  focused.classList.remove('focused');

  if(currentIndex < 0) forms[arrayLength].classList.add('focused');
  if(currentIndex > arrayLength) forms[0].classList.add('focused');
  if(currentIndex >= 0 && currentIndex <= arrayLength) forms[currentIndex].classList.add('focused');
}





// functionlities related to gift product 

function rebindCartDrawer() {  
  attachListeners();          
  updateCartCount();          
  updateCheckoutEndpoint();   
}


document.addEventListener('DOMContentLoaded', () => {
  let lastCartTotal = null;  // Variable to store the previous total
  let isProcessing = false;  // Flag to prevent re-running the function multiple times

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  function addProductToCart(productId) {
    if (isProcessing) return;

    isProcessing = true; 

    const formData = {
      items: [
        {
          id: productId,
          properties: { 'gift': 'yes' },
          quantity: 1,
        }
      ],
      sections: 'section-cart-drawer',
      sections_url: window.location.pathname
    };
    const body = JSON.stringify(formData);

    fetch(window.Shopify.routes.root + 'cart/add.js', { ...fetchConfig(), body })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error adding product to cart');
        }
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log('parsed state', parsedState)
        let cart = document.querySelector('.main-cart-drawer-parent');
        console.log('cart', cart)
        
        if (cart && parsedState.sections && parsedState.sections['section-cart-drawer']) {
          cart.innerHTML = parsedState.sections['section-cart-drawer'];
          // Otvori drawer ponovo
          const drawer = document.querySelector('.cart-drawer');
          if (drawer) {
            drawer.setAttribute('data-state', 'open');
            drawer.classList.add('active'); // ako koristiš klasu za animaciju
          }
          rebindCartDrawer();
        }
        checkCartTotal(); 
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        isProcessing = false; 
      });
  }

  function removeGiftProduct(productId) {
    if (isProcessing) return;

    isProcessing = true; 

    fetch('/cart/change.js', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: 0,
        sections: 'section-cart-drawer',
        sections_url: window.location.pathname
      })
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Error removing product from cart');
      }
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);

      let cart = document.querySelector('.main-cart-drawer-parent');
      if (cart && parsedState.sections && parsedState.sections['section-cart-drawer']) {
        cart.innerHTML = parsedState.sections['section-cart-drawer'];
        // Otvori drawer ponovo
        const drawer = document.querySelector('.cart-drawer');
        if (drawer) {
          drawer.setAttribute('data-state', 'open');
          drawer.classList.add('active'); // ako koristiš klasu za animaciju
        }
        rebindCartDrawer();
      }
      checkCartTotal(); 
    })
    .catch(error => console.error('Error removing gift product', error))
    .finally(() => {
      isProcessing = false; 
    });
  }

  function checkCartTotal() {
    const totalElement = document.querySelector('.total-see-drawer');
    if (totalElement) {
      const currentTotal = totalElement.textContent.trim();
      if (currentTotal !== lastCartTotal) {
        lastCartTotal = currentTotal; 
        runCartUpdate();
      }
    }
  }

  function runCartUpdate() {
    const addBenefitButton = document.getElementById('add-benefit-product');
    let cart = document.getElementById('cart-drawer-progress');
    const productId = cart.dataset.productId;
    const isInCart = cart.dataset.incart;

    if (addBenefitButton && isInCart === 'false') {
      addProductToCart(productId);
    } else if (!addBenefitButton && isInCart === 'true') {
      removeGiftProduct(productId);
    }
  }

  const observer = new MutationObserver(() => {
    const cartProgress = document.getElementById('cart-drawer-progress');
    if (cartProgress && cartProgress.dataset.productId) {
      runCartUpdate();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
